<template>
  <PrimeDialog
    v-model:visible="show_modal"
    :header="$t('contact.labels.selectProjectForImpersonation', { customer_name: customer.attributes.name })"
    modal
    @update:visible="$emit('close')"
  >
    <div class="flex items-center">
      <a
        v-for="project in projects_visible"
        :key="project.id"
        :href="url_impersonation(project) || undefined"
        class="button is-primary is-outlined mr-2"
        data-test="decision-type-item"
        @click="(event) => onClickProject(event, project)"
      >
        {{ $truncate(project.attributes.name, 50) }}
      </a>
    </div>
  </PrimeDialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { GroupCustomer } from '@/app/data/model_constants';
import useProfileImpersonation from '@/app/util/impersonation';

export default {
  name: 'CustomerImpersonationModal',

  props: {
    customer: { type: Object, required: true },
  },

  setup() {
    const { impersonate, impersonationURL, isProfileActive } = useProfileImpersonation();
    return { impersonate, impersonationURL, isProfileActive };
  },

  data() {
    return {
      show_modal: false,
    };
  },

  computed: {
    ...mapGetters(['current_client', 'group_customers', 'projects', 'units']),

    group_customers_visible() {
      return _.filter(this.group_customers, {
        attributes: { customer_id: this.customer.id, scope: GroupCustomer.SCOPE_VISIBLE },
      });
    },

    units_visible() {
      return _.pick(this.units, _.map(this.group_customers_visible, 'attributes.unit_id'));
    },

    projects_visible() {
      return _.pick(this.projects, _.map(this.units_visible, 'attributes.project_id'));
    },
  },

  watch: {
    customer: {
      immediate: true,
      async handler() {
        const is_active = await this.isProfileActive(this.customer);
        if (!is_active) {
          this.$emit('close');
          return;
        }
        const projects_visible = _.values(this.projects_visible);
        const project = projects_visible[0];
        if (projects_visible.length === 1) {
          const tenantable = project.attributes.dedicated ? project : this.current_client;
          this.impersonate(this.customer, tenantable);
          this.$emit('close');
        } else {
          this.show_modal = true;
        }
      },
    },
  },

  methods: {
    url_impersonation(project) {
      const tenantable = project.attributes.dedicated ? project : this.current_client;
      return this.impersonationURL(this.customer, tenantable, { validate: false, return_to: window.location.href });
    },

    onClickProject(event, project) {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const tenantable = project.attributes.dedicated ? project : this.current_client;
      this.impersonate(this.customer, tenantable, { return_to: window.location.href });
      this.$emit('close');
    },
  },
};
</script>
